<template lang="html">
  <div class="">
    <h3>Gestione Tipologie Tessere</h3>
    <br>
    <Select v-model="filters.trashed">
      <Option :value="0"><Icon type="ios-person"/> Attive</Option>
      <Option :value="1"><Icon type="ios-trash"/> Cestino</Option>
    </Select>
    &nbsp;

    <Button
    @click="$root.$emit('associate-card.show')"
    type="primary"
    style="float: right">
      <Icon type="plus-round"/>
      Nuova tipologia di tessera
    </Button>



    <div class="ivu-table spaced" style="margin: 1em 0">
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Quota associativa</th>
            <th style="width: 200px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!cards.length">
            <td colspan=3>
              Nessuna tessera trovata
            </td>
          </tr>
          <tr v-for="t in cards" :key="t.id">
            <td>{{ t.label }}</td>
            <td>{{ $n(t.price, 'currency') }}</td>
            <td style="text-align: right">
              <ButtonGroup>
                <Button type="primary" shape="circle" @click="$root.$emit('associate-card.show', t)">
                  <Icon type="edit"/>
                </Button>
                <Button v-if="!t.deleted_at" type="error" shape="circle" @click="conferma('Sicuri di cancellare questa tipologia?') && $http['delete']('associate-cards/'+t.id).then(refreshCards)">
                  <Icon type="ios-trash"/>
                </Button>
                <Button v-else type="success" shape="circle" @click="$http['delete']('associate-cards/'+t.id).then(refreshCards)">
                  Riabilita
                </Button>
              </ButtonGroup>
            </td>
          </tr>
        </tbody>
      </table>
      <Spin size="large" fix v-if="loading"/>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      cards: [],
      filters: {
        company_id: this.$store.company.id,
        trashed: 0,
      },
    }
  },

  mounted() {
    this.refreshCards()
    this.$root.$on('associate-cards', this.refreshCards)
  },
  beforeDestroy() {
    this.$root.$off('associate-cards', this.refreshCards)
  },

  methods: {
    refreshCards(page) {
      var params = Object.assign({
      }, this.filters)
      this.loading = true
      this.$http.get('associate-cards', {params}).then(res => {
        this.cards = res.data
      }).finally(res => {
        this.loading = false
      })
    },
    conferma(a) {
      return confirm(a)
    }
  },

  watch: {
    filters: {
      deep: true,
      handler: require('lodash').debounce(function() {
        this.refreshCards()
      }, 300)
    }
  }
}
</script>

<style lang="css">
</style>
